"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var ArrowBackIos_1 = __importDefault(require("@mui/icons-material/ArrowBackIos"));
var ArrowForwardIos_1 = __importDefault(require("@mui/icons-material/ArrowForwardIos"));
var FeaturedCarousel = function (_a) {
    var _b, _c;
    var books = _a.books, learnMore = _a.learnMore;
    var _d = (0, react_1.useState)(0), index = _d[0], setIndex = _d[1];
    if (books.length === 0)
        return null;
    var book = books[index];
    var prev = function () { return setIndex(function (i) { return (i - 1 + books.length) % books.length; }); };
    var next = function () { return setIndex(function (i) { return (i + 1) % books.length; }); };
    var coverUrl = (_c = (_b = book.display_url) !== null && _b !== void 0 ? _b : book.og_url) !== null && _c !== void 0 ? _c : book.cover_image_url;
    return (react_1.default.createElement(Paper_1.default, { sx: {
            position: 'relative',
            overflow: 'hidden',
            mb: 4,
            borderRadius: 2,
            border: 'none',
            background: coverUrl
                ? "linear-gradient(to right, rgba(28,8,58,0.95) 0%, rgba(50,20,91,0.88) 50%, rgba(28,8,58,0.7) 100%), url(".concat(coverUrl, ") center/cover no-repeat")
                : 'linear-gradient(135deg, #32145b 0%, #5E309F 100%)',
            color: '#fff',
            minHeight: 200,
        } },
        books.length > 1 && (react_1.default.createElement(IconButton_1.default, { onClick: prev, size: "small", "aria-label": "Previous", sx: {
                position: 'absolute',
                left: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'rgba(255,255,255,0.7)',
                '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
                zIndex: 1,
            } },
            react_1.default.createElement(ArrowBackIos_1.default, { fontSize: "small" }))),
        books.length > 1 && (react_1.default.createElement(IconButton_1.default, { onClick: next, size: "small", "aria-label": "Next", sx: {
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'rgba(255,255,255,0.7)',
                '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
                zIndex: 1,
            } },
            react_1.default.createElement(ArrowForwardIos_1.default, { fontSize: "small" }))),
        react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "center", gap: 3, sx: { px: { xs: 5, sm: 7 }, pt: 3, pb: books.length > 1 ? 1 : 3 } },
            coverUrl && (react_1.default.createElement(Box_1.default, { component: "img", src: coverUrl, alt: book.title, sx: {
                    width: { xs: 80, sm: 110 },
                    aspectRatio: '2/3',
                    objectFit: 'cover',
                    flexShrink: 0,
                    borderRadius: 1,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
                } })),
            react_1.default.createElement(Box_1.default, { flexGrow: 1, minWidth: 0 },
                react_1.default.createElement(Typography_1.default, { variant: "h5", fontWeight: 700, gutterBottom: true, sx: { color: '#fff' } }, book.title),
                book.author && (react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { color: 'rgba(255,255,255,0.75)', mb: 1 } }, book.author)),
                book.summary && (react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { color: 'rgba(255,255,255,0.85)', mb: 2 } },
                    book.summary.split(' ').slice(0, 30).join(' '),
                    book.summary.split(' ').length > 30 ? '…' : '')),
                react_1.default.createElement(Button_1.default, { variant: "outlined", href: "/app/books/".concat(book.slug), "aria-label": "".concat(learnMore, ": ").concat(book.title), sx: {
                        borderColor: 'rgba(255,255,255,0.7)',
                        color: '#fff',
                        '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
                    } }, learnMore))),
        books.length > 1 && (react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "center", gap: 0.75, pb: 1.5, pt: 1 }, books.map(function (_, i) { return (react_1.default.createElement(Box_1.default, { key: i, onClick: function () { return setIndex(i); }, sx: {
                width: i === index ? 20 : 8,
                height: 8,
                borderRadius: 4,
                bgcolor: i === index ? '#fff' : 'rgba(255,255,255,0.35)',
                cursor: 'pointer',
                transition: 'all 0.25s ease',
            } })); })))));
};
exports.default = FeaturedCarousel;
